/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_Reason_Missing_FeaturesInputs */

const en_cancel_reason_missing_features = /** @type {(inputs: Cancel_Reason_Missing_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing features I need`)
};

const de_cancel_reason_missing_features = /** @type {(inputs: Cancel_Reason_Missing_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlende Funktionen`)
};

const fr_cancel_reason_missing_features = /** @type {(inputs: Cancel_Reason_Missing_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonctionnalites manquantes`)
};

const es_cancel_reason_missing_features = /** @type {(inputs: Cancel_Reason_Missing_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faltan funciones que necesito`)
};

const it_cancel_reason_missing_features = /** @type {(inputs: Cancel_Reason_Missing_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mancano funzionalita`)
};

const nl_cancel_reason_missing_features = /** @type {(inputs: Cancel_Reason_Missing_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mist functies die ik nodig heb`)
};

const pl_cancel_reason_missing_features = /** @type {(inputs: Cancel_Reason_Missing_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brakuje funkcji`)
};

const fi_cancel_reason_missing_features = /** @type {(inputs: Cancel_Reason_Missing_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puuttuu ominaisuuksia`)
};

const da_cancel_reason_missing_features = /** @type {(inputs: Cancel_Reason_Missing_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mangler funktioner jeg har brug for`)
};

const sv_cancel_reason_missing_features = /** @type {(inputs: Cancel_Reason_Missing_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saknar funktioner jag behöver`)
};

/**
* | output |
* | --- |
* | "Missing features I need" |
*
* @param {Cancel_Reason_Missing_FeaturesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cancel_reason_missing_features = /** @type {((inputs?: Cancel_Reason_Missing_FeaturesInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_Reason_Missing_FeaturesInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cancel_reason_missing_features(inputs)
	if (locale === "fr") return fr_cancel_reason_missing_features(inputs)
	if (locale === "es") return es_cancel_reason_missing_features(inputs)
	if (locale === "it") return it_cancel_reason_missing_features(inputs)
	if (locale === "nl") return nl_cancel_reason_missing_features(inputs)
	if (locale === "pl") return pl_cancel_reason_missing_features(inputs)
	if (locale === "fi") return fi_cancel_reason_missing_features(inputs)
	if (locale === "da") return da_cancel_reason_missing_features(inputs)
	if (locale === "sv") return sv_cancel_reason_missing_features(inputs)
	return en_cancel_reason_missing_features(inputs)
});